/* eslint-disable */

import { AppState } from '../global/store'

export type History = {
  push: (path: string) => void
  go: () => void
}

export type ApiResponse = {
  [key: string]: any
}

export type ApiRequest = any

export type ChildrenProps = {
  children?: any
  [key: string]: any
}

export type Props = {
  [key: string]: any
}

export type Params = {
  [key: string]: any
}

export type SetState = (state: AppState) => void

export type NativeEvent = any

export type Window = any

export type Translation = any

export type RefElement = any

export type Callback = any

// strings aren't needed but help with test diffs
export enum RequestState {
  NotLoaded = 'NOT_LOADED',
  Loading = 'LOADING',
  Loaded = 'LOADED',
  Error = 'ERROR'
}
